<template>
    <section class="triplea-category-section">
      <div class="triplea-container">
        <div class="category-title-row">
          <div class="col-xl-5 category-title-bloc">
            <h2>
              Que estilo de imóvel combina mais com você?
            </h2>
          </div>
          <div class="col-xl-7 content-title-bloc">
            <h3>
              Imóveis personalizados que
              se encaixam com as suas preferências
            </h3>
            <a href="/triplea/busca?residencial" class="see-all-button">
              <span>
                <img src="@/assets/img/triplea/home/top-right-arrow.svg">
              </span>
              Ver todos os imóveis
            </a>
          </div>
        </div>
        <div class="category-cards-row">
          <a href="/triplea/busca?minimalista" class="category-card category-card-bg-1" title="imóveis concept">
            <img src="@/assets/img/triplea/home/category-card-bg-1.png" alt="imóveis concept" style="display: none;">
            <div class="category-card-badge">
              Minimalista
            </div>
          </a>
          <a href="/triplea/busca?exclusivo" class="category-card category-card-bg-2" title="imóveis de arquitetura autoral">
            <img src="@/assets/img/triplea/home/category-card-bg-2.png" alt="imóveis de arquitetura autoral" style="display: none;">
            <div class="category-card-badge">
              Exclusivo
            </div>
          </a>
          <a href="/triplea/busca?contemporaneo" class="category-card small category-card-bg-3" title="imóveis contemporâneos">
            <img src="@/assets/img/triplea/home/category-card-bg-3.png" alt="imóveis contemporâneos" style="display: none;">
            <div class="category-card-badge">
              Contemporâneo
            </div>
          </a>
          <a href="/triplea/busca?vintage" class="category-card small category-card-bg-4" title="imóveis vintage">
            <img src="@/assets/img/triplea/home/category-card-bg-4.png" alt="imóveis vintage" style="display: none;">
            <div class="category-card-badge">
              Vintage
            </div>
          </a>
          <a href="/triplea/busca?piscina" class="category-card small category-card-bg-5" title="imóveis com piscina">
            <img src="@/assets/img/triplea/home/category-card-bg-5.png" alt="imóveis com piscina" style="display: none;">
            <div class="category-card-badge">
              Piscina
            </div>
          </a>
          <a href="/triplea/busca?privacidade" class="category-card small category-card-bg-6" title="imóveis com privacidade">
            <img src="@/assets/img/triplea/home/category-card-bg-6.png" alt="imóveis com privacidadet" style="display: none;">
            <div class="category-card-badge">
              Mais privacidade
            </div>
          </a>
        </div>
      </div>
    </section>
</template>
<script>
  import "@/assets/scss/custom/triplea/components/_home_category_section.scss"

  export default {
    
  }
</script>
